<template>
    <div class="p-4 flex items-center min-h-screen bg-slate-900">
        <div class="w-96 mx-auto rounded-lg shadow p-6 md:p-8 bg-gray-800 border-gray-700 text-white text-xl text-center space-y-6">
            <p class="text-3xl font-bold">: (</p>
            <p>Sorry, the page you are looking for doesn't exist.</p>
        </div>
    </div>
</template>

